import { Routes } from "@angular/router";
import { DescriptionContentComponentd } from "src/app/components/dt/description-content/description-content.component";
import { DynamicContentComponentd } from "src/app/components/dt/dynamic-content/dynamic-content.component";
import { FixedContentComponentd } from "src/app/components/dt/fixed-content/fixed-content.component";
import { LoginSignupComponent } from "src/app/components/login-signup/login-signup.component";
import { LoginComponent } from "src/app/components/login/login.component";
import { DescriptionContentComponent } from "src/app/components/mobile/description-content/description-content.component";
import { DynamicContentComponent, modalClose } from "src/app/components/mobile/dynamic-content/dynamic-content.component";
import { FixedContentComponent } from "src/app/components/mobile/fixed-content/fixed-content.component";
import { MVideoComponent } from "src/app/components/mobile/fixed-content/video/video.component";
import { ModalComponent } from "src/app/components/modal/modal.component";
import { VideoComponent } from "src/app/components/video/video.component";
import { AboutComponent } from "src/app/Terms/about/about.component";
import { AdvertiseComponent } from "src/app/Terms/advertise/advertise.component";
import { ContactComponent } from "src/app/Terms/contact/contact.component";
import { PrivacyComponent } from "src/app/Terms/privacy/privacy.component";
import { TermsComponent } from "src/app/Terms/terms/terms.component";

export const routes: Routes = [
    {
        path: "",
        redirectTo: "/all/all",
        pathMatch: 'full',
    },
    {
        path: "all/all",
        redirectTo: "/all/all",
        pathMatch: 'full',
    },
    {
        path: "login1",
        component: LoginComponent,
    },
    {
        path: "login",
        component: LoginSignupComponent,
    },
    {
        path: "register",
        component: LoginSignupComponent,
    },
    {
        path: ":ctype/:termid",
        component: FixedContentComponent,
        children: [
            {
                path: "",
                canDeactivate: [modalClose],
                component: DynamicContentComponent,
                children: [
                    {
                        path: "search/:searchkey",
                        component: DynamicContentComponent,
                        children: [
                            {
                                path: "play/:vidid",
                                component: DynamicContentComponent,
                                data: {
                                    reuse: true
                                }
                            },
                            {
                                path: "play/:vidid/:vidtit",
                                component: DynamicContentComponent,
                                data: {
                                    reuse: true
                                }
                            }
                        ]
                    },
                    {
                        path: "category/:vidcattext/:vidcatid",
                        component: DynamicContentComponent,
                        children: [
                            {
                                path: "play/:vidid",
                                component: DynamicContentComponent,
                                data: {
                                    reuse: true
                                }
                            },
                            {
                                path: "play/:vidid/:vidtit",
                                component: DynamicContentComponent,
                                data: {
                                    reuse: true
                                }
                            }
                        ]
                    },
                    {
                        path: "photoalbum/:vidid/:vidtext",
                        component: DynamicContentComponent,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "play/:vidid",
                        component: DynamicContentComponent,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "play/:vidid/:vidtit",
                        component: DynamicContentComponent,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "viewall/:menuindex/:rmiid",
                        component: DynamicContentComponent,
                        data: {
                            reuse: true
                        }
                    }
                ]
            },
            {
                path: ":nodeId",
                canDeactivate: [modalClose],
                component: DescriptionContentComponent
            },
            {
                path: ":nodeId/:nodeTitle",
                canDeactivate: [modalClose],
                component: DescriptionContentComponent,
                children: [
                    {
                        path: "related-video/:relindex/:vidid",
                        component: DescriptionContentComponent
                    }
                ]
            },
            {
                path: ":nodeId/:nodeTitle/MusicAlbum",
                children: [
                    {
                        path: '',
                        component: DescriptionContentComponent,
                    },
                    {
                        path: '',
                        component: ModalComponent,
                        outlet: 'popupOutlet'
                    }
                ]
            },
            {
                path: ":nodeId/:nodeTitle/play",
                component: DescriptionContentComponent
            },
            {
                path: ":nodeId/:nodeTitle/form/:formname",
                component: DescriptionContentComponent
            }
        ]
    },
    {
        path: ":ctype/:termid/video/:nodeId",
        component: MVideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: ":ctype/:termid/video/:nodeId/:vidtext",
        component: MVideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: "videoad",
        component: MVideoComponent,
        data: {
            reuse: true
        }
    },
    { path: 'popup', component: ModalComponent, outlet: 'popupOutlet' },
    {
        path: "n/:ctype/:termid/category/:vidcattext/:vidcatid",
        component: MVideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: "about-us",
        component: AboutComponent,
    },
    {
        path: "privacy-policy",
        component: PrivacyComponent,
    },
    {
        path: "advertise",
        component: AdvertiseComponent,
    },
    {
        path: "terms-of-use",
        component: TermsComponent,
    },
    {
        path: "contact-us",
        component: ContactComponent,
    },
];

export const routesDsk: Routes = [
    {
        path: "",
        redirectTo: "all/all",
        pathMatch: 'full',
    },
    {
        path: "all/all",
        redirectTo: "all/all",
        pathMatch: 'full',
    },
    {
        path: "login1",
        component: LoginComponent,
    },
    {
        path: "login",
        component: LoginSignupComponent,
    },
    {
        path: "register",
        component: LoginSignupComponent,
    },
    {
        path: ":ctype/:termid",
        component: FixedContentComponentd,
        children: [
            {
                path: "",
                canDeactivate: [modalClose],
                component: DynamicContentComponentd,
                children: [
                    {
                        path: "search/:searchkey",
                        component: DynamicContentComponentd,
                        children: [
                            {
                                path: "play/:vidid",
                                component: DynamicContentComponentd,
                                data: {
                                    reuse: true
                                }
                            },
                            {
                                path: "play/:vidid/:vidtit",
                                component: DynamicContentComponentd,
                                data: {
                                    reuse: true
                                }
                            }
                        ]
                    },
                    {
                        path: "category/:vidcattext/:vidcatid",
                        component: DynamicContentComponentd,
                        children: [
                            {
                                path: "play/:vidid",
                                component: DynamicContentComponentd,
                                data: {
                                    reuse: true
                                }
                            },
                            {
                                path: "play/:vidid/:vidtit",
                                component: DynamicContentComponentd,
                                data: {
                                    reuse: true
                                }
                            }
                        ]
                    },
                    {
                        path: "photoalbum/:vidid/:vidtext",
                        component: DynamicContentComponentd,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "play/:vidid",
                        component: DynamicContentComponentd,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "play/:vidid/:vidtit",
                        component: DynamicContentComponentd,
                        data: {
                            reuse: true
                        }
                    },
                    {
                        path: "viewall/:menuindex/:rmiid",
                        component: DynamicContentComponentd,
                        data: {
                            reuse: true
                        }
                    }
                ]
            },
            {
                path: ":nodeId",
                canDeactivate: [modalClose],
                component: DescriptionContentComponentd
            },
            {
                path: ":nodeId/:nodeTitle",
                canDeactivate: [modalClose],
                component: DescriptionContentComponentd,
                children: [
                    {
                        path: "related-video/:relindex/:vidid",
                        component: DescriptionContentComponentd
                    }
                ]
            },
            {
                path: ":nodeId/:nodeTitle/MusicAlbum",
                children: [
                    {
                        path: '',
                        component: DescriptionContentComponentd,
                    },
                    {
                        path: '',
                        component: ModalComponent,
                        outlet: 'popupOutlet'
                    }
                ]
            },
            {
                path: ":nodeId/:nodeTitle/play",
                component: DescriptionContentComponentd
            },
            {
                path: ":nodeId/:nodeTitle/form/:formname",
                component: DescriptionContentComponentd
            }
        ]
    },
    {
        path: ":ctype/:termid/video/:nodeId",
        component: VideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: ":ctype/:termid/video/:nodeId/:vidtext",
        component: VideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: "videoad",
        component: VideoComponent,
        data: {
            reuse: true
        }
    },
    { path: 'popup', component: ModalComponent, outlet: 'popupOutlet' },
    {
        path: "n/:ctype/:termid/category/:vidcattext/:vidcatid",
        component: VideoComponent,
        data: {
            reuse: true
        }
    },
    {
        path: "about-us",
        component: AboutComponent,
    },
    {
        path: "privacy-policy",
        component: PrivacyComponent,
    },
    {
        path: "advertise",
        component: AdvertiseComponent,
    },
    {
        path: "terms-of-use",
        component: TermsComponent,
    },
    {
        path: "contact-us",
        component: ContactComponent,
    },
];
